import { service } from '../../../service';

const state = {
  loading: false,
  items: []
};


const actions = {

  fetchLogs({ commit, rootState }) {
    commit('setLoading', true)

    return service.get(`/logs/${rootState.account.company._id}/${rootState.account.location._id}`).then(
      result => commit('setLogs', result.logs)
    )
  },

  fetchLogsByUser({ commit, rootState }, userid) {
    commit('setLoading', true)

    return service.get(`/logs/${rootState.account.company._id}/${rootState.account.location._id}/${userid}`).then(
      result => {
        commit('setLoading', false)
        return result
      }
    )
  },

  async createLog({ dispatch, commit, rootState }, payload) {

    var result = await service.post(`/logs/${rootState.account.company._id}/${rootState.account.location._id}`, payload)
    if (result) {
      commit('newLog', result.log)
    }
    return
  },

  deleteLogs({ commit, rootState }) {
    commit('setLoading', true)

    return service.delete(`/logs/${rootState.account.company._id}/${rootState.account.location._id}`).then(
      result => {
        commit('setLogs', [])
        return
      }
    )
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setLogs(state, logs) {
    state.items = logs
    state.loading = false
  },
  newLog(state, log) {
    state.items.push(log)
    state.loading = false
  },
};

export const logs = {
  namespaced: true,
  state,
  actions,
  mutations
};
